import { render, staticRenderFns } from "./q-pop-payCost.vue?vue&type=template&id=12cc23cb&scoped=true&"
import script from "./q-pop-payCost.vue?vue&type=script&lang=js&"
export * from "./q-pop-payCost.vue?vue&type=script&lang=js&"
import style0 from "./q-pop-payCost.vue?vue&type=style&index=0&id=12cc23cb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cc23cb",
  null
  
)

export default component.exports